/**
 * 支付渠道
 * 暂时不支持查询子渠道
 * create by sevencai@2018/4/15
 * contact seven.cailidan@gmail.com
 * 发票项目中，渠道为
 * 微信支付  wechat
 * QQ钱包   qqwallet
 * 网银支付  bank    仅限子渠道80
 */
export default {
  qqcard: "QQ卡",
  cftpay: "财付通",
  wechat: "微信支付",
  hfpay: "手机话费",
  qqacct: "Q币支付",
  qdqb: "Q币支付",
  qbqd: "Q币支付",
  qqpoint: "Q币支付",
  redeem: "兑换券",
  pccft: "快捷支付",
  pcbank: "网银支付",
  mcard: "手机充值卡",
  wechatapp: "小程序支付",
  "bank:39": "QQ钱包",
  "bank:51": "QQ钱包",
  "bank:63": "QQ钱包",
  "bank:64": "QQ钱包",
  "bank:69": "QQ钱包",
  "bank:71": "财付通余额",
  "bank:72": "财付通快捷",
  "bank:73": "网银支付",
  "bank:74": "刷卡支付",
  "bank:75": "财付通",
  "bank:80": "网银支付",
  "bank:82": "网银支付",
  friendpay: "好友代付",
  iap: "IAP支付",
  qqwallet: "QQ钱包",
  other: "其它"
}
